<template>
    <div class="d-flex flex-column">
        <div class="ml-auto mr-0 mb-3" v-if="!addNewItem  && !editItem && !showItem">
            <button class="btn btn-outline-green" @click="onAddNewItem">
                Создать расчёт
            </button>
        </div>

        <b-table
            v-if="!addNewItem && !editItem && !showItem"
            :items.sync="items"
            :fields="fields"
            thead-class="thead-color"
            hover
            show-empty
            sort-icon-left
            :stacked="stacked"
            responsive
            no-local-sorting
        >
            <template #empty="scope">
                <p class="my-4"><em>Расчеты не найдены. Добавьте новый расчет.</em></p>
            </template>

            <template #cell(actions)="row">
                <div class="ml-auto mr-auto text-center">
                    <action-order-outsourcing
                        :row.sync="row"
                        :actionAllows="calcActionAllows"
                        @showItem="onShowItem"
                        @editItem="onEditItem"
                        @deleteItem="onDeleteItem"
                        @approveOrderOutsourcing="approveOrderOutsourcing"
                    />
                </div>
            </template>
        </b-table>

        <tsoft-add-new-outsourcing 
            v-if="addNewItem"
            @saveNewItem="saveNewItem"
            @cancelAddNewItem="cancelAddNewItem"
        />

        <tsoft-edit-outsourcing
            v-if="editItem"
            :copyItem="item"
            @cancelEditItem="cancelEditItem"
            @saveEditItem="saveEditItem"
        />

        <tsoft-show-outsourcing
            v-if="showItem"
            :item="item"
            @cancelShowItem="cancelShowItem"
        />
    </div>

</template>

<script>
import { API_ORDER_OUTSOURCE } from '@/constants';

import tsoftAddNewOutsourcing from '@components/orders/orderOutsourcing/AddNewOutsourcing';
import tsoftEditOutsourcing from '@components/orders/orderOutsourcing/EditOutsourcing';
import tsoftShowOutsourcing from '@components/orders/orderOutsourcing/ShowOutsourcing';
import actionOrderOutsourcing from '@components/tables/actions/actionOrderOutsourcing';

export default {
    components: {
        tsoftAddNewOutsourcing,
        tsoftEditOutsourcing,
        tsoftShowOutsourcing,
        actionOrderOutsourcing,
    },

    props: {
        order_id: { type: Number | String, required: false },
    },

    data() {
        return {
            addNewItem: false,
            editItem: false,
            showItem: false,
            row: null,
            actionAllows: ['edit', 'show', 'delete', 'approve'],
            fields: [],
            items: [],
            item: {},
        }
    },

    computed: {
        stacked() {
            const stackedBreakpoints = ['sm'];
            return stackedBreakpoints.includes(this.$mq);
        },

        calcActionAllows() {
            if (this.onCheckSelectedVariant()) {
                this.actionAllows = ['edit', 'show', 'delete', 'unApprove'];
            } else {
                this.actionAllows = ['edit', 'show', 'delete', 'approve'];
            }
            return this.actionAllows
        }
    },

    methods: {
        getItems() {
            axios.get(`${API_ORDER_OUTSOURCE}?order_id=${this.order_id}&as-table=1`).then(({ data }) => {
                this.fields = data.headers;
                data.data.forEach(item => {
                    // add property id and order_id to propertiesFlatten
                    item.propertiesFlatten = Object.assign(
                        {
                            id: item.id, 
                            order_id: item.order_id, 
                            selected_variant: item.selected_variant
                        }, item.propertiesFlatten);
                    this.items.push(item.propertiesFlatten);
                });
            });
        },

        translateDate() {
            let date = new Date();
            return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear();
        },

        onAddNewItem() {
            this.addNewItem = true;
        },

        cancelAddNewItem() {
            this.addNewItem = false;
        },

        cancelEditItem() {
            this.editItem = false;
            this.row = null;
        },

        cancelShowItem() {
            this.showItem = false;
            this.row = null;
        },

        saveNewItem(item) {
            let newItem = {order_id: this.order_id};
            let properties = item;
            newItem.properties = properties;
            
            axios.post(`${API_ORDER_OUTSOURCE}`, newItem).then((data) => {
                item = Object.assign(
                    {
                        id: data.data.id, 
                        order_id: this.order_id,
                        selected_variant: 0
                    }, item);
                this.items.unshift(item);
            })
            this.addNewItem = false;
        },

        saveEditItem(item) {
            this.items[this.row] = item;

            let newItem = {order_id: this.order_id};
            let properties = item;
            newItem.properties = properties;

            axios.put(`${API_ORDER_OUTSOURCE}/${item.id}`, newItem);

            this.editItem = false;
            this.row = null;
        },

        onShowItem(row) {
            this.onAction(row);
            this.showItem = true;
        },

        onEditItem(row) {
            this.onAction(row);
            this.editItem = true;
        },

        onAction(row) {
            this.item = this.items[row.index];
            this.row = row.index;
        },

        onDeleteItem(row) {
            this.items.splice(row.index, 1);
            axios.delete(`${API_ORDER_OUTSOURCE}/${row.item.id}`);
        },

        approveOrderOutsourcing(row) {
            // 1 or 0 by clicking
            this.items[row.index].selected_variant = +!!!+this.items[row.index].selected_variant;

            let newItem = {order_id: this.order_id, selected_variant: this.items[row.index].selected_variant};
            let properties = this.items[row.index];
            newItem.properties = properties;

            axios.put(`${API_ORDER_OUTSOURCE}/${this.items[row.index].id}`, newItem);
            this.row = null;
        },

        onCheckSelectedVariant() {
            let result = false;
            this.items.forEach(item => {
                if (item.selected_variant == 1) {
                    result = true;
                }
            })
            return result;
        }
    },

    mounted() {
        this.getItems();
    },
}
</script>

